












































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { institutionServer, patrolManagementServe, performanceServer } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';
import TreeUnit from '@/components/tree/treeUnit.vue';
import PagingUnit from '@/components/paging/paging.vue';
import dayjs from 'dayjs';
import XLSX from 'xlsx';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: { CollapseTransition, TreeUnit, PagingUnit },
  mixins: [TableStripe],
})
export default class PatrolReport extends Vue {
  private spaceList: any = []; // 单位列表
  private subSpaceByAuthOptions: any = []; // 部门列表
  private activeName: any = 'day';

  private filterForm: any = {
    date: '',
    startDate: '',
    endDate: '',
    // spaceId: '',
    bancorTopId: '',
    month: '',
    monthDate: '',
    week: '',
    weekNotNatural: [],
    monthNotNatural: [],
  };
  private dayTableData: any = [];
  private tableLoading: any = [];
  private weekTableData: any = [];
  private monthTableData: any = [];
  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc Vue 创建数据生命周期
   * @param1 暂无
   * @returns 暂无
   */
  created() {
    const nowDate: any = new Date();
    this.filterForm.date = dayjs(nowDate).format('YYYY-MM-DD');
    this.filterForm.startDate = dayjs(nowDate.getTime() - 3600 * 1000 * 24 * 6).format('YYYY-MM-DD');
    this.filterForm.endDate = dayjs(nowDate).format('YYYY-MM-DD');
    this.filterForm.month = dayjs(nowDate).format('YYYY-MM');
    this.getSubSpaceByAuth();
    this.getDateReportList();
  }
  /**
   * 【接口】获取日报表
   */
  private getDateReportList() {
    this.tableLoading = true;
    patrolManagementServe
      .getPatrolReportDayListData({
        date: this.filterForm.date,
        bancorId: this.filterForm.bancorTopId,
      })
      .then((res: any) => {
        this.tableLoading = false;
        if (res.code === '200') {
          this.dayTableData = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.tableLoading = false;
        this.$message.warning('网络异常，请稍后重试。');
      });
  }
  private handleSpaceChangeDay(e: any) {
    this.getDateReportList();
  }
  private handleChangeDateDay() {
    this.getDateReportList();
  }

  /**
   * 【接口】获取周报表
   */
  private getWeekReportList() {
    let startDate: any = '';
    let endDate: any = '';
    if (this.activeName === 'month') {
      startDate = this.filterForm.monthNotNatural[0];
      endDate = this.filterForm.monthNotNatural[1];
    } else {
      if (this.filterForm.week) {
        startDate = dayjs(new Date(this.filterForm.week).getTime() - 3600 * 1000 * 24).format('YYYY-MM-DD');
        endDate = dayjs(new Date(this.filterForm.week).getTime() + 3600 * 1000 * 24 * 5).format('YYYY-MM-DD');
      } else if (this.filterForm.weekNotNatural) {
        startDate = this.filterForm.weekNotNatural[0];
        endDate = this.filterForm.weekNotNatural[1];
      } else {
        startDate = this.filterForm.startDate;
        endDate = this.filterForm.endDate;
      }
    }
    this.tableLoading = true;
    patrolManagementServe
      .getPatrolReportWeekListData({
        startDate,
        endDate,
        bancorId: this.filterForm.bancorTopId,
      })
      .then((res: any) => {
        this.tableLoading = false;
        if (res.code === '200') {
          this.weekTableData = res.data;
          this.monthTableData = this.activeName === 'month' ? res.data : [];
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch(() => {
        this.tableLoading = false;
        this.$message.warning('网络异常，请稍后重试。');
      });
  }
  private handleSpaceChangeWeek(e: any) {
    this.getWeekReportList();
  }
  /**
   *【按钮】改变日历周
   * @Params
   * @return
   **/
  private handleChangeWeek(e: any) {
    this.filterForm.weekNotNatural = [];
    this.getWeekReportList();
  }
  private handleChangeWeekNotNatural(e: any) {
    this.filterForm.week = '';
    this.getWeekReportList();
  }
  /**
   * 【接口】获取月报表
   */
  private getMonthReportList() {
    const date: any = this.filterForm.monthDate || this.filterForm.month;
    this.tableLoading = true;
    patrolManagementServe
      .getPatrolReportMonthListData(date, {
        bancorId: this.filterForm.bancorTopId,
      })
      .then((res: any) => {
        this.tableLoading = false;
        if (res.code === '200') {
          this.monthTableData = res.data;
        } else {
          this.$message.warning(res.msg);
          throw new Error();
        }
      })
      .catch(() => {
        this.tableLoading = false;
        this.$message.warning('网络异常，请稍后重试。');
      });
  }
  private handleSpaceChangeMonth(e: any) {
    this.getMonthReportList();
  }
  /**
   *【按钮】改变日历月份
   * @Params
   * @return
   **/
  private handleChangeMonth(e: any) {
    this.filterForm.monthNotNatural = [];
    this.getMonthReportList();
  }
  private handleChangeMonthNotNatural(e: any) {
    this.filterForm.monthDate = '';
    if (e) {
      this.getWeekReportList();
    } else {
      this.getMonthReportList();
    }
  }

  /**
   *【标签页】标签页点击切换触发函数
   * @Params
   * @return
   **/
  handleClick(tab: any, event: any) {
    switch (tab.name) {
      case 'day':
        this.getDateReportList();
        break;
      case 'week':
        this.getWeekReportList();
        break;
      case 'month':
        this.getMonthReportList();
        break;
    }
  }
  exportTableData() {
    let tableComponents: any = null;
    let worksheet: any = null;
    let workbook: any = null;
    switch (this.activeName) {
      case 'day':
        console.log('日报表');
        tableComponents = document.getElementById('tableListDay');
        worksheet = XLSX.utils.table_to_sheet(tableComponents);
        workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '日报表');
        try {
          XLSX.writeFile(workbook, '日报表.xlsx');
        } catch (e) {
          console.log(e, workbook);
        }
        break;
      case 'week':
        tableComponents = document.getElementById('tableListWeek');
        worksheet = XLSX.utils.table_to_sheet(tableComponents);
        workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '周报表');
        try {
          XLSX.writeFile(workbook, '周报表.xlsx');
        } catch (e) {
          console.log(e, workbook);
        }
        break;
      case 'month':
        tableComponents = document.getElementById('tableListMonth');
        worksheet = XLSX.utils.table_to_sheet(tableComponents);
        workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '月报表');
        try {
          XLSX.writeFile(workbook, '月报表.xlsx');
        } catch (e) {
          console.log(e, workbook);
        }
        break;
    }
  }
}
